import api from './index'

export default {
  // 获取绑定状态
  getBindStatus(params) {
    return new Promise((resolve, reject) => {
      api.call('get', '/wechat_account/', params, (res) => {
        resolve(res)
      })
    })
  },
  // 解绑
  unbindWx(params) {
    return new Promise((resolve, reject) => {
      api.call('delete', '/wechat_account/', params, (res) => {
        resolve(res)
      })
    })
  },
  // 绑定
  bind(params) {
    return api.post('/third_party/bind', params)
  },
  // 获取渲染微信二维码的 url
  getWxQrcodeUrl(params) {
    return new Promise((resolve, reject) => {
      api.call('post', '/wechat_account/generate_oa_bind_qrcode/', params, (res) => {
        resolve(res)
      })
    })
  },
}
